import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "state" }
const _hoisted_2 = { class: "state-tit" }
const _hoisted_3 = { class: "num" }



interface Props {
  title: string,
  count: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardState',
  props: {
    title: {},
    count: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.count), 1)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})